// We use  'requestId' of VerifySession.
export const postJumioInfoEndpoint = '/ocr-ms/ms/jumio/ext/info';
export const postJumioDocStatusEndpoint = '/ocr-ms/ms/docStatus';
export const postJumioDocStatusEndpointSso = '/ocr-ms/v1/sso/ocr/docStatus';
